import { Form, FormInstance } from "antd";
import { useCallback, useEffect } from "react";
import ReportService from "../../../../../services/reportGeneration";
import { useAttachmentTools } from "../../../../../lib/hooks/useAttachmentTools";
import { useGetTaskGenerateReport } from "../../../../../lib/hooks/useGetTaskStatus";

export const useGenerateAttachment = (
  form: FormInstance,
  contractId: string,
  setGlobalIsLoading: (value: boolean) => void
) => {
  const templateId = Form.useWatch("templateId", form);

  const { setError, onFail } = useAttachmentTools(form, setGlobalIsLoading);

  const { getStatus } = useGetTaskGenerateReport(
    form,
    setGlobalIsLoading,
    setError,
    onFail
  );

  const generate = useCallback(async () => {
    if (templateId) {
      setError([]);
      setGlobalIsLoading(true);

      const reportId: string = await Promise.resolve(
        ReportService.generateEmailLetterReport(templateId.value, contractId)
      );

      await getStatus(reportId);
    }
  }, [templateId, setError, setGlobalIsLoading, contractId, getStatus]);

  useEffect(() => {
    generate();
  }, [generate]);
};
